import DeleteDialog from "@components/DeleteDialog"
import Dialog from "@components/Dialog"
import { DashboardConfigurationDialogProps } from "@features/builder/DashboardConfiguration/types"
import { useGraphDocument } from "@features/builder/GraphDocumentProvider/hooks/useGraphDocument"
import { GraphDetails } from "@features/builder/types"
import { Button } from "@mui/material"
import { dashboardApi, useDeleteDashboardFileMutation } from "@store/services/dashboardService"
import logger from "@utils/logger"
import { enqueueSnackbar } from "notistack"
import { SetState } from "@custom-types/utils"
import { updateGraphDocumentData } from "@utils/crdt"
import { FORM_ID } from "@features/builder/DashboardConfiguration/DashboardConfiguration"
import { useAppDispatch } from "@store/hooks"

export const DashboardConfigurationDialog = (
  props: DashboardConfigurationDialogProps & {
    children: React.ReactNode
    onIsDeleteOpen: SetState<boolean>
    isDeleteOpen: boolean
  },
) => {
  const [deleteDashboardFile] = useDeleteDashboardFileMutation()
  const graphDocument = useGraphDocument()
  const dispatch = useAppDispatch()

  const onDeleteClickHandler = async () => {
    if (!graphDocument) return
    // remove from the CRDT doc
    const graphData = JSON.parse(
      graphDocument.getMap("graph").get("data")?.toJSON() ?? "null",
    ) as GraphDetails | null

    if (!graphData) {
      logger.error(`Graph data does not exist on graph "${props.graphKey}"`)
      return
    }

    // request deletion of the dangling dashboard file
    if (props.graphKey) {
      await deleteDashboardFile(props.graphKey).unwrap()

      graphData.DashboardS3Location = ""
      graphData.DashboardS3Hash = ""
      updateGraphDocumentData(graphDocument, graphData)
      enqueueSnackbar({ variant: "success", message: "Dashboard deleted successfully" })
      dispatch(dashboardApi.util.invalidateTags(["dashboard"]))
      props.onIsDeleteOpen(false)
    }
  }

  return (
    <>
      <Dialog
        open
        onClose={props.onClose}
        title="Dashboard configuration"
        fullScreen
        disableEscapeKeyDown
        actionsComponent={
          <>
            <Button type="submit" variant="contained" form={FORM_ID}>
              Save
            </Button>
          </>
        }
      >
        {props.children}
      </Dialog>
      <DeleteDialog
        open={props.isDeleteOpen}
        setOpen={props.onIsDeleteOpen}
        onDeleteClick={onDeleteClickHandler}
      />
    </>
  )
}
